/** @jsxImportSource @emotion/react */

import {
  Card,
  Input,
  Typography,
  removeScaleFromMoney,
  useTheme,
} from '@quickbit/qb-design-system';
import { AccountingReport } from 'tabs/Accounting/types';

const hideReporting = true;

export const AccountingReporting = (props: AccountingReport) => {
  const { spacing } = useTheme();
  // Temporarily hide reporting while we figure out what to report
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (hideReporting) return null;
  return (
    <Card>
      <Typography variant="subtitle">Reporting - {props.reportType}</Typography>
      <div
        css={{
          display: 'grid',
          gap: spacing.xxs,
          marginTop: spacing.xxs,
        }}
      >
        <div css={{ display: 'flex', gap: spacing.xxxs }}>
          <Input
            value={props.periodStart.toLocaleString()}
            onChange={() => ({})}
            label="Start time"
          />
          <Input
            value={props.periodEnd.toLocaleString()}
            onChange={() => ({})}
            label="End time"
          />
        </div>
        <Input
          value={props.transactionsCount.toString()}
          onChange={() => ({})}
          label="Number of transactions"
        />

        {props.reportLines.map((line, index) => (
          <div key={'report-line-' + index.toString()}>
            <Typography variant="bodyMedium">
              {line.account} - {line.accountName}
            </Typography>
            <div css={{ marginBottom: spacing.xxxs }} />
            <Input
              onChange={() => ({})}
              label={'Euro value'}
              value={removeScaleFromMoney(line.euroValue).toString()}
              endAdornment="€"
            />
            {line.cryptoValue && (
              <Input
                onChange={() => ({})}
                label={'Crypto value'}
                value={removeScaleFromMoney(line.cryptoValue).toString()}
                endAdornment={line.cryptoValue.currencyCode}
              />
            )}
            {line.debit && (
              <Input
                onChange={() => ({})}
                label={'Debit'}
                value={removeScaleFromMoney(line.debit).toString()}
                endAdornment={line.debit.currencyCode}
              />
            )}
            {line.credit && (
              <Input
                onChange={() => ({})}
                label={'Credit'}
                value={removeScaleFromMoney(line.credit).toString()}
                endAdornment={line.credit.currencyCode}
              />
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};
